import React, { useState } from "react";
import { toast } from "react-toastify";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import PrintIcon from "@mui/icons-material/Print";
import { Router, useNavigate } from "react-router-dom";

// import JS files
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import MuiButton from "../../../shares/MuiButton";
import PanelTable from "../../../shares/PanelTable";
import OrderDetails from "./OrderDetails";

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
  { colName: "code_one", name: "تعداد یک" },
  { colName: "code_two", name: "تعداد دو" },
  { colName: "code_three", name: "تعداد سه" },
  { colName: "code_four", name: "تعداد چهار" },
  { colName: "code_five", name: "تعداد پنج" },
  { colName: "code_six", name: "تعداد شش" },
  { colName: "details", name: "جزییات" },
];
const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
  { colName: "details", name: "جزییات" },
];

const dataKey = [
  "code",
  "show_name",
  "gender",
  "color",
  "created_at",
  "size_one_num",
  "size_two_num",
  "size_three_num",
  "size_four_num",
  "size_five_num",
  "size_six_num",
];

const AdminReportsInventory = () => {
  const navigate = useNavigate();
  const [codeFilter, setCodeFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);

  const update_filter = (state, e) => {
    if (state == "brand") setBrandFilter(e);
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    getRequestListApi.reFetch();
  };

  const reset_filter = () => {
    setBrandFilter(null);
    setCodeFilter(null);
    getRequestListApi.reFetch();
  };

  const buttonsList = [
    {
      label: "مشاهده جزییات",
      component: (it) => (
        <OrderDetails selectedRow={it} getRequestListApi={getRequestListApi} />
      ),
    },
  ];

  const actionsList = [
    // {
    //   label: "ثبت سفارش",
    //   component: () => <SubmitOrder />,
    // },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const [requestList, setRequestList] = useState({ results: [] });

  const getRequestListApi = useFetch({
    method: "get",
    params: {
      brand: brandFilter,
      code: fixNumbers(codeFilter),
      // show_changed: true,
    },
    url: "BangleStock_Service",
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });

  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",

    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",
      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
  ];

  const handelPrintReport = () => {
    navigate("/print-report-inventory");
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="r-inventory">
        <>
          <div className="panel-main-header">
            <span>موجودی</span>
          </div>
          <PanelFilter
            header="فیلتر :"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست النگوهای قابل ثبت سفارش:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={requestList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AddShoppingCartIcon />}
            // setSelectedRow={setSelectedRow}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default AdminReportsInventory;
